module.exports = __webpack_public_path__ + "static/img/a071.d3b5a14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a071.jpg
// module id = 0ewm
// module chunks = 0